import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

const pulse = keyframes`
  0%, 100% {
    opacity: 0.55;
    transform: scale(0.96);
  }

  50% {
    opacity: 1;
    transform: scale(1);
  }
`;

export const LoadingPage = styled.section`
  min-height: 100vh;
  width: 100%;
  display: grid;
  place-items: center;
  padding: var(--space-xxl);
  /* background: var(--offWhite); */
`;

export const LoadingCard = styled.div`
  width: min(100%, 420px);
  padding: var(--space-xxl);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-l);
  text-align: center;
`;

export const Spinner = styled.div`
  width: 72px;
  height: 72px;
  border-radius: 50%;

  background: conic-gradient(
    from 90deg,
    var(--yellow1),
    var(--yellow4),
    var(--orange3),
    var(--orange5),
    var(--yellow2),
    var(--yellow1)
  );

  animation:
    ${spin} 0.9s linear infinite,
    ${pulse} 1.8s ease-in-out infinite;

  position: relative;

  &::after {
    content: '';
    position: absolute;
    inset: 9px;
    border-radius: 50%;
    background: var(--white);
    box-shadow: inset 0 0 0 1px var(--grey1);
  }
`;

export const TextGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-xs);

  h2 {
    margin: 0;
    color: var(--grey7);
    font-size: clamp(1.7rem, 4vw, 2.4rem);
    line-height: 1;
  }

  p {
    margin: 0;
    color: var(--grey4);
    font-size: 1rem;
    line-height: 1.6;
  }
`;
